import React from 'react';
import { IInvoiceRecipient } from '../../../../InvoiceCreation/types/types';

export const emailTemplate = (recipient: IInvoiceRecipient) => (
  <div className='flex items-center   max-w-[30ch]'>
    <span title={recipient.email} className='font-metricR text-[16px] text-bw08 truncate'>{recipient.email}</span>
  </div>
);
